<div *ngIf="connectionStatus == 1" class="spinner-border spinner-border-sm text-warning mt-1"></div>
<i *ngIf="connectionStatus == 2" class="bi bi-check-lg text-success"></i>
<i *ngIf="connectionStatus == 0" class="bi bi-x-lg text-danger"></i>
<span class="mb-0"> {{langStrings[connectionStatusTypes[connectionStatus]]}}</span>